import { useLocation } from "@tanstack/react-router";
import { Button } from "@/ui/button";
import { UserMenu } from "@/components/UserMenu";
import { lookupRouteTitle } from "@/lib/routeTitles";
import { NotificationBell } from "@/features/notifications/NotificationBell";
import { usePermission } from "@/lib/authv2/permissions";
import { ACTION } from "@/lib/auth/actions";
import { Menu } from "lucide-react";

export function Header({ onMenuToggle }: { onMenuToggle?: () => void }) {
  const canNotify = usePermission(ACTION.NotificationRead);
  const { pathname } = useLocation();
  const title = lookupRouteTitle(pathname);

  return (
    <header
      className="flex h-14 shrink-0 items-center justify-between gap-2 border-b bg-surface px-4 md:px-6"
      style={{ borderColor: "var(--color-border)" }}
    >
      <div className="flex items-center gap-2 min-w-0">
        <h1
          className="truncate text-lg font-semibold md:text-xl"
          style={{ color: "var(--color-text)", fontFamily: "var(--font-display)" }}
        >
          {title}
        </h1>
      </div>
      <div className="flex items-center gap-1">
        {/* Vai không đọc được thông báo (Chỉ xem, vai đã khoá) thì không có
            chuông — trước đây chuông hỏi máy chủ mỗi trang, mỗi phút và bị
            từ chối (kiểm thử đóng vai 17/10/2026, M13 / L2-14). */}
        {canNotify ? <NotificationBell /> : null}
        <UserMenu />
        {/* Nút menu đứng NGOÀI CÙNG BÊN PHẢI trên điện thoại.
            Góc trên-trái là chỗ khó với nhất của ngón cái phải khi cầm máy một
            tay, mà đây lại là nút bấm nhiều nhất (đi màn khác). Đo 26/09/2026:
            21 nút của các màn nằm trong góc đó. Trên máy tính nút tự ẩn vì đã
            có thanh menu dọc cố định. */}
        {onMenuToggle && (
          <Button
            variant="ghost"
            size="icon"
            className="shrink-0 md:hidden"
            onClick={onMenuToggle}
            aria-label="Mở menu"
          >
            <Menu size={20} />
          </Button>
        )}
      </div>
    </header>
  );
}
